import { render, staticRenderFns } from "./SpendingSlider.vue?vue&type=template&id=cc0d8002&scoped=true&"
import script from "./SpendingSlider.vue?vue&type=script&lang=js&"
export * from "./SpendingSlider.vue?vue&type=script&lang=js&"
import style0 from "./SpendingSlider.vue?vue&type=style&index=0&id=cc0d8002&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0d8002",
  null
  
)

export default component.exports